<script>
import FormListView from "./FormListView.vue";
import DialogImportExcel from "./DialogImportExcel.vue";
import {isAdministrator} from "../layout/navigation";

const TITLES = {
    rtb7: 'Rent increase notices',
    rtb30: 'End of tenancy notices',
    'inspection-report': 'Inspection reports',
};

export default {
    name: "FormList",
    components: {DialogImportExcel, FormListView},
    computed: {
        type() {
            return (this.$route.query.type || '');
        },
        title() {
            return TITLES[this.type] || 'All forms';
        },
        isAdmin() {
            return isAdministrator(this.$store.getters.userInfo || {});
        },
    },
    methods: {
        onMore(cmd) {
            if (cmd === 'import') this.$refs.excelModal.open();
        },
    },
}
</script>

<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div>
                <div class="page-kicker">Notices &amp; forms</div>
                <h2>{{ title }}</h2>
            </div>
            <div class="page-actions">
                <router-link v-if="type === 'rtb7' && isAdmin" class="el-button el-button--default el-button--small" to="/rent-increase">Monthly run &amp; settings</router-link>
                <router-link v-if="type === 'rtb7'" class="el-button el-button--primary el-button--small" to="/buildium/lease-rents">Create rent increases</router-link>
                <router-link v-if="type === 'rtb30'" class="el-button el-button--primary el-button--small" to="/buildium/rental-units">New end of tenancy notice</router-link>
                <a v-if="type === 'inspection-report'" class="el-button el-button--primary el-button--small" href="/inspection-report" target="_blank" rel="noopener">Write a report</a>
                <el-dropdown v-if="type === 'rtb7' || !type" trigger="click" @command="onMore">
                    <el-button size="small">More <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="import">Import rent increases from Excel…</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <form-list-view ref="listView" :show-tabs="true"/>
        <dialog-import-excel ref="excelModal" @success="$refs.listView.fetchList()"/>
    </main-layout>
</template>
